/**
 * 나의 공급가 입력 규칙 — 화면과 서버(`UpdateSupplierItemSettingsDto`)가 같은 규칙을 쓴다.
 *
 * - 원 단위 정수만. 천 단위 쉼표는 받아 준다(화면이 그렇게 보여 주므로).
 * - 소수점·음수·숫자 아닌 글자는 **고쳐 쓰지 않고 거절**한다. 예전에는 글자를 말없이 지워
 *   `12.5` 가 `125`, `-500` 이 `500` 으로 저장됐다(GS 검수 V-14).
 * - 상한은 견적서 단가 상한(`quoteResponseValidator`, 999,999,999원)과 같다.
 */
export const MAX_SUPPLIER_PRICE = 999_999_999;

export const SUPPLIER_PRICE_INPUT_MESSAGES = {
  negative: "음수는 입력할 수 없습니다.",
  decimal: "소수점 없이 원 단위로 입력해주세요.",
  notNumber: "숫자만 입력해주세요.",
  tooLarge: "공급가는 999,999,999원 이하로 입력해주세요.",
} as const;

export type SupplierPriceInputCheck =
  | { ok: true; value: number }
  | { ok: false; message: string };

/** 입력칸 글자를 검사한다. 빈칸은 0(미입력)이다. */
export function checkSupplierPriceInput(text: string): SupplierPriceInputCheck {
  const raw = text.replace(/,/g, "").trim();
  if (raw === "") return { ok: true, value: 0 };
  if (raw.startsWith("-")) {
    return { ok: false, message: SUPPLIER_PRICE_INPUT_MESSAGES.negative };
  }
  if (/^\d*\.\d*$/.test(raw)) {
    return { ok: false, message: SUPPLIER_PRICE_INPUT_MESSAGES.decimal };
  }
  if (!/^\d+$/.test(raw)) {
    return { ok: false, message: SUPPLIER_PRICE_INPUT_MESSAGES.notNumber };
  }
  const value = Number(raw);
  if (value > MAX_SUPPLIER_PRICE) {
    return { ok: false, message: SUPPLIER_PRICE_INPUT_MESSAGES.tooLarge };
  }
  return { ok: true, value };
}

/** 검사를 통과한 값을 칸에 보일 모양으로 — 빈칸은 빈칸, 나머지는 천 단위 쉼표. */
export function formatPriceInput(text: string, value: number): string {
  return text.replace(/,/g, "").trim() === "" ? "" : value.toLocaleString();
}
